// Remembers how the visitor arrived (first page in this tab) so bookings can be attributed in Reports
const KEY = "mw_attribution";

export const captureAttribution = () => {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const p = new URLSearchParams(window.location.search);
    const attr = {
      referrer: document.referrer || "",
      landing_page: window.location.pathname,
      utm_source: p.get("utm_source") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "",
    };
    sessionStorage.setItem(KEY, JSON.stringify(attr));
  } catch { /* storage unavailable */ }
};

export const getAttribution = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; }
};
